import { applyMiddleware, legacy_createStore as createStore } from 'redux';
import { createWrapper } from 'next-redux-wrapper';
import { composeWithDevTools } from '@redux-devtools/extension';

import rootReducer from 'reducer/reducer';

const bindMiddleware = (middleware) => {
    if (process.env.NODE_ENV !== 'production') {
        return composeWithDevTools(applyMiddleware(...middleware));
    }
    return applyMiddleware(...middleware);
};

export const makeStore = () => {
    const store = createStore(rootReducer, bindMiddleware([]));

    return store;
};

export const wrapper = createWrapper(makeStore, { debug: false });
